/**
 * Contour Instances — list (read-only, `[PROPOSED]`).
 *
 * `frontend-entity-coverage §2.3`: ContourInstance is PROPOSED, backed by
 * `/api/contour-instances` (`11 §2.1`); relations are Artifact · Contour ·
 * ArtifactPositions · transitions · lifecycle. Discoverable labeled-empty
 * teaser until the endpoint ships.
 */
import { Workflow } from "@/components/ui/icon";

import { ProposedListPage } from "../_shared/ProposedModule";

export function ContourInstanceList() {
  return (
    <ProposedListPage
      title="Contour Instances"
      description="A live run of a contour over an artifact — its positions, transitions, and lifecycle."
      icon={Workflow}
      endpoint="/api/contour-instances"
      emptyTitle="No contour instances yet"
      testId="contour-instances-empty"
    />
  );
}

export default ContourInstanceList;
